// extracted by mini-css-extract-plugin
export var body = "_d6-0";
export var sectionHeader = "_d6-4";
export var shortcutColumns = "_d6-2";
export var shortcutList = "_d6-1";
export var shortcutSection = "_d6-3";